import React, { Component } from 'react';

import { MinMax } from './styles';
import { formatAmount } from '../../../../utils/commonUtil';
import PropTypes from 'prop-types';

class Input extends Component {
  render() {
    const { onChange, min, max, defaultValue, noForamtter,step, value } = this.props;
    return (
      <MinMax
        step={step}
        onChange={onChange}
        min={min}
        max={max}
        value={value}
        defaultValue={defaultValue}
        formatter={value => (noForamtter ? value : `${formatAmount(value)}`)}
      />
    );
  }
}
Input.propTypes = {
  noForamtter:PropTypes.bool,
  defaultValue:PropTypes.number.isRequired,
  max:PropTypes.number.isRequired,
  min:PropTypes.number.isRequired,
  onChange:PropTypes.func.isRequired,
  step:PropTypes.number.isRequired,
  value:PropTypes.number
}
export default Input;
